export enum HMCATableViewMode {
  HMCA,
  ClassLocation
}
